export const maintenance_item_recommendation = [
  {
    parts_name: "机油过滤器",
    parts_icon: require("@/assets/maintain/engine-oil-filter.png"),
    parts_attribute: "5000km或6个月/次",
  },
  {
    parts_name: "空气过滤器",
    parts_icon: require("@/assets/maintain/engine-air-filter.png"),
    parts_attribute: "10000km或12个月/次",
  },
  {
    parts_name: "空调过滤器",
    parts_icon: require("@/assets/maintain/engine-conditioning-filter.png"),
    parts_attribute: "12个月/次",
  },
  {
    parts_name: "轮胎",
    parts_icon: require("@/assets/maintain/engine-oil-tire.png"),
    parts_attribute: "50000km或48个月/次",
  },
  {
    parts_name: "轮毂",
    parts_icon: require("@/assets/maintain/engine-oil-hub.png"),
    parts_attribute: "检查使用情况，必要时更换",
  },
  {
    parts_name: "主雨刮",
    parts_icon: require("@/assets/maintain/engine-oil-wiper.png"),
    parts_attribute: "6个月/次",
  },
  {
    parts_name: "副雨刮",
    parts_icon: require("@/assets/maintain/engine-oil-vice-wiper.png"),
    parts_attribute: "6个月/次",
  },
];
